import {
  getPeriodBoundariesFromStartDateAndGranularity,
  shiftDateToNearestGranularity,
} from '../../../../common';
import { ShiftDirectionEnum } from '../../../../common/enum/shift-direction.enum';
import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { MetricValueType } from '../../../../interface/dtos';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../../../interface/dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';
import { ChallengeInsightProgressFocusV1SummaryAggregateRoot } from '../../../domain/aggregates/challenge-insights/challenge-insight-progress-focus-v1.aggregate-root';
import { GetChallengeInsightProgressFocusV1SummaryDomainService } from '../../../domain/services/challenge-insights/get-challenge-insight-progress-focus-v1-summary.domain-service';
import { OrganizationWorkingSessionsPort } from '../../ports/working-sessions/organization-working-sessions.port';

export class GetChallengeInsightProgressFocusV1SummaryApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: OrganizationWorkingSessionsPort,
    protected readonly domainService: GetChallengeInsightProgressFocusV1SummaryDomainService
  ) {}

  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressFocusV1SummaryAggregateRoot> {
    try {
      this.logManager.debug(
        'Called GetChallengeInsightProgressFocusV1SummaryApplicationService'
      );

      const shiftedEndDate = shiftDateToNearestGranularity({
        date: new Date(props.params.endDate),
        granularity: props.params.granularity,
        direction: ShiftDirectionEnum.Left,
      });
      const [entities, todayEntities] = await Promise.all([
        this.port.getAverageFocusScoreForUserIdsForDateRange({
          userIds: props.params.userIds,
          startDate: props.params.startDate,
          endDate: props.params.endDate,
          segments: props.params.segments ?? undefined,
          departmentId: props.params.departmentId ?? undefined,
          token: props.config.token,
        }),
        this.port.getAverageFocusScoreForUserIdsForDateRange({
          startDate: shiftedEndDate.toISOString().split('T')[0],
          endDate: props.params.endDate,
          userIds: props.params.userIds,
          token: props.config.token,
          departmentId: props.params.departmentId ?? undefined,
        }),
      ]);
      return await this.domainService.execute({
        entities,
        systemDayEntities: todayEntities,
        type: MetricValueType.Score,
        targetValue: props.params.challengeTargetValue,
      });
    } catch (error) {
      this.logManager.error(error);
      throw new InternalServerErrorException(error);
    }
  }
}
